import React, { useState, useEffect } from "react";
import { API } from "../backend";
import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
// import Footer from "../../Component/Footer";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import Logo from "../../images/logo.png";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { styled } from "@mui/system";
import { useFlutterwave } from "flutterwave-react-v3";
import Swal from "sweetalert2";
import ProceedModalPrint from "../../Component/ProceedModalPrint";
import BulkPublic from "../../Component/BulkPublic";
import IndividualPublic from "../../Component/IndividualPublic";
import { useSelector } from "react-redux";
import Layout from '../../reusables/layout/layout';
import RequsitionPublic from '../../Component/requisitionforms/requisitionPublic';

// const CustomTextField = styled(TextField)({
//   "& .MuiInputBase-input.Mui-disabled": {
//     color: "rgba(0,0,0,0.6) !important",
//     "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
//     borderColor: "rgba(0,0,0,0.6) !important",
//   },
// });

const Public = () => {

  const token = useSelector((state) => state?.user?.data?.token);


  return (
    <div>
      <Layout>
        {token &&
          <RequsitionPublic examType={'PUBLIC SERVICE EXAMINATION'} examName={'Public Service'} />

        }
        {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
      </Layout>


    </div>
  );
};

export default Public;